import {Card, openDeleteDialog} from 'platform/components';
import {Box} from 'platform/foundation';
import {match} from 'ts-pattern';

import {mergeAll} from 'ramda';
import {isArray} from 'ramda-adjunct';

import {useDeleteRmaRequestItemsMutation} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {catchUnhandledDataGridActions, DmsDataGrid, handleApiError} from '@dms/shared';

import type {ActionCallback, QueryFilterObject} from 'features/eag-grid';

const RMA_REQUEST_ITEM_GRID_CODE = 'warehouse_rma_request_item';

interface RmaRequestItemsProps {
  rmaRequestId: string;
}

export function RmaRequestItems(props: RmaRequestItemsProps) {
  const [deleteRmaRequestItems] = useDeleteRmaRequestItemsMutation();

  const actionCallback: ActionCallback = ({actionKey, rowId, refreshData, deselectAll}) => {
    match(actionKey)
      .with('delete', () => {
        const itemIds = isArray(rowId) ? rowId : [rowId];

        openDeleteDialog({
          onConfirm: () =>
            deleteRmaRequestItems({rmaRequestId: props.rmaRequestId, body: {itemIds}})
              .unwrap()
              .then(() => refreshData())
              .then(() => deselectAll())
              .catch(handleApiError),
        });
      })
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  const queryModifier = (filter: QueryFilterObject) =>
    mergeAll([filter, {rmaRequestId: props.rmaRequestId}]);

  return (
    <Card isFullHeight title={i18n.t('entity.warehouse.labels.listOfItems')}>
      <Box height="100%">
        <DmsDataGrid
          gridCode={RMA_REQUEST_ITEM_GRID_CODE}
          actionCallback={actionCallback}
          queryModifier={queryModifier}
        />
      </Box>
    </Card>
  );
}
